import React, { ReactElement, useCallback } from "react";
import { CoObjectItem } from "../interfaces/CoObject";
import {
  ElaborationStatusItem,
  elaborationStatusItemIsBlocking,
} from "../../redux/feature/object/remote-elaborations-slice";
import { useFilteredElaborations } from "./GenericElaborationSelector";
import { useAppSelector } from "../../redux/hooks/hooks";

export interface ObjectElaborationSelectorProps {
  coObject: CoObjectItem;
  children: (coObject: CoObjectItem, elaborationItem?: ElaborationStatusItem) => ReactElement;
}

export const ObjectElaborationSelector: React.FunctionComponent<ObjectElaborationSelectorProps> = (props) => {
  const { coObject } = props;

  const addedElaborationItemDesc = useAppSelector((store) => store.remoteElaborations.addedElaborationItemsList);

  const addedElaborationsDetails = useAppSelector((store) => store.remoteElaborations.addedElaborationItemsList);
  const objectElabFindFunction = useCallback(
    (item: ElaborationStatusItem) =>
      item.contentControlId == coObject.contentControlId &&
      item.elaborationType !== "EXPORT" &&
      item.elaborationType !== "IMPORT" &&
      elaborationStatusItemIsBlocking(item, addedElaborationsDetails),
    //has to handle SHEET_AND_AREA type elaboration
    [coObject.contentControlId, addedElaborationItemDesc]
  );

  const elaborationItem = useFilteredElaborations({
    findFunction: objectElabFindFunction,
  });

  return props.children(coObject, elaborationItem);
};
